import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Banknote, Smartphone, CreditCard, Landmark, HelpCircle, DollarSign } from "lucide-react";

export const PAY_METHODS = [
  { key: "cash", label: "Cash", icon: Banknote },
  { key: "zelle", label: "Zelle", icon: Landmark },
  { key: "venmo", label: "Venmo", icon: Smartphone },
  { key: "cashapp", label: "Cash App", icon: DollarSign },
  { key: "card", label: "Card (in person)", icon: CreditCard },
  { key: "other", label: "Other", icon: HelpCircle },
];

export default function PaidViaDialog({ open, onClose, onConfirm, amountLabel, title = "How did they pay?" }) {
  const [busy, setBusy] = useState(false);
  const pick = async (key) => {
    setBusy(true);
    try { await onConfirm(key); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="paid-via-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-[#0C2E2B]">{title}</DialogTitle>
          <DialogDescription>{amountLabel ? `Recording ${amountLabel} as paid. ` : ""}Pick the method so your income report stays accurate.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {PAY_METHODS.map((m) => (
            <Button key={m.key} data-testid={`paid-via-${m.key}`} disabled={busy} variant="outline" onClick={() => pick(m.key)} className="h-12 justify-start rounded-md font-bold border-2 hover:border-[#0C2E2B] hover:bg-[#FFDF00]/20">
              <m.icon className="w-4 h-4 mr-2 text-[#0C2E2B]" /> {m.label}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
